<template>
  <!-- <button
    @click="showAddPresModel"
    class="btn btn-primary btn-sm mt-2 ms-5 mb-0"
  >
    <span class="fw-bold">+</span> Make New Presc. Sale
  </button> -->

  <button
    @click="showAddSaleModel"
    class="btn btn-outline-secondary btn-sm mt-2 ms-3 mb-0"
  >
    <span class="fw-bold">+</span> Make New Product Sale
  </button>

  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <th
        width="10%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        width="25%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Patient Name
      </th>
      <th
        width="10%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        OPD/IPD
      </th>
      <th
        width="15%"
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Phone Contact
      </th>
      <th
        width="20%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        DateTime
      </th>
      <!-- <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Gender
              </th> -->

      <th width="20%" class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 v-if="user.name != null" class="mb-0 text-sm">
                {{ user.name }}
              </h6>
              <h6 v-else style="color: grey" class="mb-0 text-sm">
                <span v-if="user.pres_note != 'OTC Sale'">{{
                  user.pres_note
                }}</span>
                <span v-if="user.pres_note == 'OTC Sale'">{{
                  "OTC_" + form_date(user.created_at)
                }}</span>
              </h6>
              <p v-if="user.email != null" class="text-xs text-secondary mb-0">
                {{ user.email == null ? "" : user.email }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p v-if="user.opd != null" class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd }}
          </p>
          <p v-if="user.ipd != null" class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">{{
            user.phone == null ? "---" : user.phone
          }}</soft-badge>
        </td>
        <td class="align-middle text-center text-sm">
          {{ form_date(user.created_at) }}
          <!-- {{ user.created_at }} -->
        </td>
        <!-- <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">{{
                    user.gender == null
                      ? "--"
                      : user.gender == 1
                      ? "Male"
                      : user.gender == 2
                      ? "Female"
                      : "Other"
                  }}</span>
                </td> -->
        <td class="align-middle">
          <button
            @click="showIssuePrescription(user.id)"
            style="
              border: 1px solid black;
              padding: 4px;
              color: green;
              font-weight: bold;
            "
          >
            Issue/Edit</button
          >.
          <button
            @click="showViewPrescription(user.id)"
            style="
              border: 1px solid purple;
              padding: 4px;
              color: blue;
              font-weight: bold;
            "
          >
            View
          </button>
        </td>
      </tr>
    </template>
  </BaseLayout>
  <IssuePrescriptionModal
    :pres_id="current_pres_id"
    v-if="showIssuePrescriptionModal"
    @close-add-pres-modal="closePresMod"
  />
  <IssuePipPrescriptionModal
    :pres_id="current_pres_id"
    v-if="showPipViewPrescriptionModal"
    @close-view-pres-modal="closePipMod"
  />
  <AddPrescriptionModal
    v-if="showAddPrescriptionModal"
    @close-add-pres-modal="closeAddPresModel"
    :store_id="2"
    :visit_id="0"
  />

  <SalesModal
    v-if="showAddSalesModal"
    :store_id="2"
    @close-make-sales-model="closeSalesModal"
  />

  <!-- v-if="show_add_lab_test_modal"
    @close-add-pres-modal="hideCreateTestModel"
    :store_id="2"
    :visit_id="visit_id" -->
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import IssuePrescriptionModal from "./issue_prescription_modal.vue";
import IssuePipPrescriptionModal from "./pip_view_prescription_modal.vue";
import AddPrescriptionModal from "./add_prescription_modal.vue";
import SalesModal from "./add_sales_modal.vue";
import BaseLayout from "../../Patients/components/table_page_layout.vue";
import form_date from "../../../timezone/utc_local_time";
//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      current_pres_id: "",
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "search_view_department_prescriptions",
      mainUrl: "view_department_prescriptions", //"getCompanyUsers",
      showIssuePrescriptionModal: false,
      showAddPrescriptionModal: false,
      showPipViewPrescriptionModal: false,
      showAddSalesModal: false,
    };
  },
  components: {
    BaseLayout,
    IssuePrescriptionModal,
    AddPrescriptionModal,
    IssuePipPrescriptionModal,
    SalesModal,
  },

  methods: {
    form_date,
    handle_external_mount(payload) {
      this.users = payload;
      // console.log(this.users);
    },
    showIssuePrescription(pres_id) {
      this.current_pres_id = pres_id;
      // console.log(this.current_pres_id);
      this.showIssuePrescriptionModal = true;
    },
    showViewPrescription(pres_id) {
      this.current_pres_id = pres_id;
      // console.log(this.current_pres_id);
      this.showPipViewPrescriptionModal = true;
    },
    closePipMod() {
      this.current_pres_id = "";
      this.showPipViewPrescriptionModal = false;
    },
    closePresMod() {
      this.showIssuePrescriptionModal = false;
      window.location.reload();
    },
    closeAddPresModel() {
      this.showAddPrescriptionModal = false;
      window.location.reload();
    },
    showAddPresModel() {
      this.showAddPrescriptionModal = true;
    },
    showAddSaleModel() {
      this.showAddSalesModal = true;
    },
    closeSalesModal() {
      this.showAddSalesModal = false;
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
